import { useQuery } from '@tanstack/react-query';
import { api } from './api';
import { queryKeys } from './queryClient';
import type { DepartmentSummary } from '../types';

/**
 * Fetch every department (active and inactive) for pickers and filters
 *
 * @returns Promise resolving to department summaries ordered by name
 */
const fetchDepartments = async (): Promise<DepartmentSummary[]> => {
  return api.get<DepartmentSummary[]>('/departments');
};

/**
 * Hook: Fetch departments for the contract department picker and list filter
 *
 * Inactive departments are included so a contract's current department stays
 * selectable; callers filter on `isActive` for new assignments.
 */
export const useDepartments = () => {
  return useQuery({
    queryKey: queryKeys.departments.list(),
    queryFn: fetchDepartments,
    staleTime: 1000 * 60 * 10, // 10 minutes
  });
};
